import { cn } from "@/lib/utils";

export default function Section({ children, className, fullWidth = false, noPadding = false }: { children: React.ReactNode, className?: string, fullWidth?: boolean, noPadding?: boolean }) {
  return (
    <section className={cn(
        !fullWidth && "max-w-screen-xl mx-auto",
        !noPadding && "px-6 md:px-12",
        noPadding || fullWidth && "px-0",
        className, 
      )}
    >
      {children}
    </section>
  )
}